// ReportNANDA.jsx
import React, { useState } from 'react';
import {
  Box, Typography, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Paper, Tabs, Tab, Chip
} from '@mui/material';


export default function ReportNANDA({ report }) {
  const [tab, setTab] = useState(0);

  if (!report) return null;

  return (
    <Box>
      <Typography variant="h5" sx={{ mb: 2, fontWeight: 'bold', color: '#1976d2' }}>
        Report Infermieristico
      </Typography>

      <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ mb: 2 }}>
        <Tab label={`NANDA (${report.nanda?.length ?? 0})`} />
        <Tab label={`NOC (${report.noc?.length ?? 0})`} />
        <Tab label={`NIC (${report.nic?.length ?? 0})`} />
      </Tabs>

      {/* NANDA */}
      {tab === 0 && (
        <TableContainer component={Paper} variant="outlined">
          <Table size="small">
            <TableHead sx={{ backgroundColor: '#e3f2fd' }}>
              <TableRow>
                <TableCell><b>Diagnosi</b></TableCell>
                <TableCell><b>Definizione</b></TableCell>
                <TableCell><b>Fattori correlati</b></TableCell>
                <TableCell><b>Caratteristiche definenti</b></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {report.nanda?.map((row, i) => (
                <TableRow key={i} hover>
                  <TableCell sx={{ fontWeight: 'bold', minWidth: 200 }}>{row.diagnosi}</TableCell>
                  <TableCell sx={{ minWidth: 220 }}>{row.definizione}</TableCell>
                  <TableCell>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                      {row.fattoriCorrelati?.map((f, j) => (
                        <Chip key={j} label={f} size="small" color="warning" variant="outlined" />
                      ))}
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                      {row.caratteristicheDefinenti?.map((c, j) => (
                        <Chip key={j} label={c} size="small" color="info" variant="outlined" />
                      ))}
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {/* NOC */}
      {tab === 1 && (
        <TableContainer component={Paper} variant="outlined">
          <Table size="small">
            <TableHead sx={{ backgroundColor: '#e8f5e9' }}>
              <TableRow>
                <TableCell><b>Diagnosi correlata</b></TableCell>
                <TableCell><b>Outcome</b></TableCell>
                <TableCell><b>Indicatori</b></TableCell>
                <TableCell><b>Scala</b></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {report.noc?.map((row, i) => (
                <TableRow key={i} hover>
                  <TableCell sx={{ fontWeight: 'bold', minWidth: 200 }}>{row.diagnosi_correlata}</TableCell>
                  <TableCell sx={{ minWidth: 200 }}>{row.outcome}</TableCell>
                  <TableCell>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                      {row.indicatori?.map((ind, j) => (
                        <Chip key={j} label={ind} size="small" color="success" variant="outlined" />
                      ))}
                    </Box>
                  </TableCell>
                  <TableCell>{row.scala}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {/* NIC */}
      {tab === 2 && (
        <TableContainer component={Paper} variant="outlined">
          <Table size="small">
            <TableHead sx={{ backgroundColor: '#fce4ec' }}>
              <TableRow>
                <TableCell><b>Diagnosi correlata</b></TableCell>
                <TableCell><b>Intervento</b></TableCell>
                <TableCell><b>Azioni</b></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {report.nic?.map((row, i) => (
                <TableRow key={i} hover>
                  <TableCell sx={{ fontWeight: 'bold', minWidth: 200 }}>{row.diagnosi_correlata}</TableCell>
                  <TableCell sx={{ minWidth: 200 }}>{row.intervento}</TableCell>
                  <TableCell>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                      {row.azioni?.map((a, j) => (
                        <Chip key={j} label={a} size="small" color="error" variant="outlined" />
                      ))}
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
}